"use client";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/PlaidConnectFlow/steps/PlaidExitRetentionGeneralStep";

import React from "react";
import { cn } from "utils";

const I18n = I18nUtil.createScoped(Translations);

export interface PlaidExitRetentionGeneralStepProps {
  isMobile: boolean;
  onContinueConnect: () => void;
  onAddManuallyInstead: () => void;
  onConfirmExit: () => void;
  onClose?: () => void;
  /** Onboarding 入口隐藏手动新增（仅允许 Plaid） */
  showAddManually?: boolean;
}

export const PlaidExitRetentionGeneralStep: React.FC<
  PlaidExitRetentionGeneralStepProps
> = ({
  isMobile,
  onContinueConnect,
  onAddManuallyInstead,
  onConfirmExit,
  onClose,
  showAddManually = true,
}) => {
  return (
    <div
      className={cn(
        "flex h-full w-full overflow-y-auto",
        isMobile ? "flex-col justify-end" : "items-center justify-center",
      )}
      onClick={onClose}
      data-openreplay-label="plaidconnectflow_retention_general_close"
    >
      {/* or-label: n/a —— stopPropagation，关闭在遮罩层已采集 */}
      <div
        className={cn(
          "relative flex shrink-0 flex-col overflow-hidden bg-background_solid_neutral_secondary text-content_primary",
          isMobile ? "w-full rounded-t-2xl pb-6" : "w-[480px] rounded-xl pb-8",
        )}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Figma Graphic 精确导出：H5 资产包含 grabber，PC 资产不包含。 */}
        <img
          src={
            isMobile
              ? "/assets/images/plaid/retention/exit-intent-h5.png"
              : "/assets/images/plaid/retention/exit-intent-pc.png"
          }
          alt="Ed keeps watching"
          className="h-auto w-full shrink-0 object-contain"
        />

        <div
          className={cn(
            "flex w-full flex-col gap-6",
            isMobile ? "px-4 pt-6" : "px-8 pt-8",
          )}
        >
          <div className="flex flex-col gap-2 text-center">
            <h2 className="headline_regular_m tracking-[-0.96px] text-content_primary">
              {I18n.t("Ed works best with your accounts")}
            </h2>
            <p className="body_l text-content_secondary">
              {I18n.t(
                "Without them I'm working from estimates. With them, every move I hand you is your real money.",
              )}
            </p>
          </div>

          <div className="flex w-full flex-col gap-3">
            <button
              type="button"
              onClick={onContinueConnect}
              className="button md_button primary_button button_m h-11 w-full rounded-lg"
              data-openreplay-label="plaid_exit_retention_connect"
            >
              {I18n.t("Connect account")}
            </button>

            {showAddManually && (
              <button
                type="button"
                onClick={onAddManuallyInstead}
                className="button md_button secondary_button button_m h-11 w-full rounded-lg border-[1.25px] border-border_inverse_transparent20"
                data-openreplay-label="plaid_exit_retention_add_manually"
              >
                {I18n.t("Add manually")}
              </button>
            )}

            <button
              type="button"
              onClick={onConfirmExit}
              className="button md_button text_button button_m h-11 w-full rounded-lg text-content_tertiary"
              data-openreplay-label="plaid_exit_retention_not_now"
            >
              {I18n.t("Continue without connecting")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
